
    // @ts-nocheck
    // This file is auto generated
    export const iconsListData = [
  {
    "name": "ai-assistant",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "ai-assistent": {
        "weight": "light"
      }
    }
  },
  {
    "name": "ampersand",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "ampersand": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "application-bending",
    "keywords": [
      "services-icon-bending-tools"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "application-bending": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-cutting",
    "keywords": [
      "hotspot-fertigung-schneiden"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "application-cutting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-flame-cutting",
    "keywords": [
      "application-icon-flame-cutting"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "application-flame-cutting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-laser-blanking-coil",
    "keywords": [
      "application-laser-blanking-coil"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "application-icon-laser-blanking-coil": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-laser-blanking-press",
    "keywords": [
      "application-laser-blanking-press"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "application-icon-laser-blanking-press": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-laser-cutting",
    "keywords": [
      "application-icon-laser-cutting"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "application-laser-cutting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "application-plasma-cutting",
    "keywords": [
      "application-icon-plasma-cutting"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "application-plasma-cutting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "archive",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "archive": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-down",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-small-down": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-download",
    "keywords": [
      "startpage-icon-downloadcenter"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "download-arrow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "arrow-left",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-small-left": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-right",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-small-right": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-rotate-bottom",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "reset": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "arrow-rotate-top",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "reload": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "arrow-up",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-small-up": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "automation",
    "keywords": [
      "smart-factory-icon-automation",
      "hotspot-automatisierung"
    ],
    "categories": [
      "smart factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "automation": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-calculation",
    "keywords": [
      "hotspot-angebotserstellung"
    ],
    "categories": [
      "people",
      "hotspot"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-calculation": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-circle",
    "keywords": [
      "profil"
    ],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-circle-small": {
        "weight": "bold"
      },
      "nav-profile": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "avatar-column",
    "keywords": [
      "culture",
      "responsibility-culture-social",
      "responsibility-icon-culture-social"
    ],
    "categories": [
      "people",
      "responsibility"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-culture": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-connectivity",
    "keywords": [],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-connectivity": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-contact",
    "keywords": [
      "icon-newsroom-press-contact"
    ],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-contact": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-customer-admin",
    "keywords": [
      "customer_admin_easyorder"
    ],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-customer-admin": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-customer-multiple",
    "keywords": [
      "customer-report-icon-number-of-employees"
    ],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-customer-multiple": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-customer",
    "keywords": [
      "person"
    ],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-customer": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-dialog",
    "keywords": [
      "responsibility-icon-society"
    ],
    "categories": [
      "people",
      "responsibility"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-dialog": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-hand-star",
    "keywords": [],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-hand-star": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-hand",
    "keywords": [],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-hand": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-multiple",
    "keywords": [
      "responsibility-icon-employees"
    ],
    "categories": [
      "people",
      "responsibility"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-multiple": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-plus",
    "keywords": [
      "services-icon-mytrumpf"
    ],
    "categories": [
      "people",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-plus": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-service",
    "keywords": [],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-service": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-star",
    "keywords": [],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-star": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-technical-service",
    "keywords": [
      "contact-general-technical-service"
    ],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-technical-service": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar-wrench-list",
    "keywords": [
      "missions"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "avatar-wrench",
    "keywords": [
      "services-icon-technical-services",
      "person_pocket-wrench"
    ],
    "categories": [
      "people",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-wrench": {
        "weight": "light"
      }
    }
  },
  {
    "name": "avatar",
    "keywords": [
      "contact-general",
      "person_pocket",
      "startpage-icon-contact-general"
    ],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar": {
        "weight": "light"
      }
    }
  },
  {
    "name": "backpack",
    "keywords": [
      "culture",
      "career-icon-school-students"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "backpack": {
        "weight": "light"
      }
    }
  },
  {
    "name": "badge-5-checkmark",
    "keywords": [
      "services-icon-5-year-warranty"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "warranty-5-years": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bag",
    "keywords": [
      "career-icon-professionals"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "bag": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bank",
    "keywords": [
      "services-icon-financing"
    ],
    "categories": [
      "financial",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "financial-bank": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bell-slash",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "no-notification": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bell",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "nav-notification": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "bin",
    "keywords": [
      "icon_delete",
      "trash",
      "trash-can"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "delete": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "book",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "nav-success-story": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "bookmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "fav": {
        "weight": "light"
      },
      "fav-filled": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "books",
    "keywords": [
      "career-icon-students"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "books": {
        "weight": "light"
      }
    }
  },
  {
    "name": "box-cog-multiple",
    "keywords": [
      "services-icon-genuine-parts"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "genuine-parts": {
        "weight": "light"
      }
    }
  },
  {
    "name": "box-open-checkmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "order-status-package-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "box-open",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "box-open": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "box-star",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "box-star": {
        "weight": "light"
      }
    }
  },
  {
    "name": "box",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "box": {
        "weight": "light"
      }
    }
  },
  {
    "name": "bullet-points",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "list": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "calculator",
    "keywords": [
      "services-icon-financial-calculator"
    ],
    "categories": [
      "services",
      "financial"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "financial-calculator": {
        "weight": "light"
      }
    }
  },
  {
    "name": "calendar",
    "keywords": [
      "startpage-icon-events-calendar"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "calendar": {
        "weight": "light"
      }
    }
  },
  {
    "name": "camera-cross",
    "keywords": [
      "camera_denied"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "camera-denied": {
        "weight": "light"
      }
    }
  },
  {
    "name": "camera",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "camera": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-bending-tools",
    "keywords": [
      "services-icon-e-shop-bending-tools"
    ],
    "categories": [
      "e-shop",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cart-bending-tools": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-checkmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cart-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-circle-hand",
    "keywords": [
      "mytrumpf-icon-easyorder"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "shop-order": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-cogs",
    "keywords": [
      "services-icon-e-shop-genuine-parts"
    ],
    "categories": [
      "e-shop",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cart-genuine-parts": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart-punching-tools",
    "keywords": [
      "services-icon-e-shop-punching-tools"
    ],
    "categories": [
      "e-shop",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cart-punching-tools": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cart",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cart": {
        "weight": "normal"
      },
      "nav-shopping-cart": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "carts",
    "keywords": [
      "hotspot-intralogistik"
    ],
    "categories": [
      "hotspot"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "intralogistics": {
        "weight": "light"
      }
    }
  },
  {
    "name": "certificate",
    "keywords": [
      "services-icon-AM-certification"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "certificate": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-growth",
    "keywords": [
      "smart-factory-icon-your-benefits"
    ],
    "categories": [
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "financial-grow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-magnifier",
    "keywords": [
      "services-icon-visual-assistances"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "progress-magnifier": {
        "weight": "light"
      },
      "magnifier-chart": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-progress-circle-arrows",
    "keywords": [
      "services-icon-process-optimization"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "financial-grow-circle": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-progress-money",
    "keywords": [
      "customer-report-icon-sales"
    ],
    "categories": [
      "financial"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "financial-sales": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chart-turning-point",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "call-predictive": {
        "weight": "light"
      }
    }
  },
  {
    "name": "checklist-eye",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "checklist-eye": {
        "weight": "light"
      }
    }
  },
  {
    "name": "checkmark-magnifier",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "checkmark-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "checkmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "checkmark-rounded-thin": {
        "weight": "normal"
      },
      "checkmark": {
        "weight": "bold"
      },
      "checkmark-thin": {
        "weight": "light"
      }
    }
  },
  {
    "name": "chevron-down",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-down": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-download",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "download": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "chevron-inwards",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "zoom-in": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-left-double",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-nav-left-double": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-left",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold",
      "normal",
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-big-left": {
        "weight": "light"
      },
      "arrow-left": {
        "weight": "normal"
      },
      "arrow-nav-left": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-outwards",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "zoom-out": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-right-double",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-nav-right-double": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-right",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold",
      "normal",
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "arrow-big-right": {
        "weight": "light"
      },
      "arrow-right": {
        "weight": "normal"
      },
      "arrow-nav-right": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "chevron-scroll-down-double",
    "keywords": [
      "arrow",
      "scroll"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "chevron-scroll-down-end",
    "keywords": [
      "arrow",
      "scroll"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "chevron-scroll-down",
    "keywords": [
      "arrow",
      "scroll"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "chevron-up",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "chevron-upload",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "upload": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "circle-bin",
    "keywords": [
      "trash",
      "trashcan_circle_bg-red"
    ],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "light"
    ],
    "description": "",
    "legacyNames": {
      "delete-circle-red": {
        "weight": "light",
        "filled": true
      }
    }
  },
  {
    "name": "circle-chart",
    "keywords": [
      "easy_order_cockpit",
      "services-icon-easy-order-cockpit",
      "mytrumpf-icon-performance-cockpit"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "performance-cockpit": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-checkmark",
    "keywords": [],
    "categories": [
      "status"
    ],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [
      "normal"
    ],
    "description": "",
    "legacyNames": {
      "circle-checked": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "circle-chevron-right",
    "keywords": [
      "arrow-right_rounded_circle"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "circle-arrow-right": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-cross",
    "keywords": [
      "circle-filled-gray_cross"
    ],
    "categories": [
      "status"
    ],
    "outlineWeights": [],
    "filledWeights": [
      "normal"
    ],
    "description": "",
    "legacyNames": {
      "circle-filled-cross": {
        "weight": "normal",
        "filled": true
      }
    }
  },
  {
    "name": "circle-eye",
    "keywords": [
      "stufen_eye-icon"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "circle-eye": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-hand",
    "keywords": [
      "stufen_hand-icon"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "circle-hand": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-info",
    "keywords": [
      "stufen_info-icon",
      "info-border",
      "info-circle-filled",
      "mytrumpf-icon-info"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "info-rounded": {
        "weight": "light"
      },
      "info-circle": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "circle-play",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "play-rounded": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-plus",
    "keywords": [
      "plus-rounded_circle"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "circle-plus": {
        "weight": "light"
      },
      "plus-rounded": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-questionmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold",
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "circle-questionmark": {
        "weight": "bold"
      },
      "faq": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-slash",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "circle-declined": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "circle-two-arrows",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "circle-two-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "circle-warning",
    "keywords": [
      "exclamation mark"
    ],
    "categories": [
      "status"
    ],
    "outlineWeights": [],
    "filledWeights": [
      "normal"
    ],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "circle",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "circle-empty": {
        "weight": "normal"
      },
      "circle-filled": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "circles",
    "keywords": [
      "smart-factory-icon-why-TruConnect"
    ],
    "categories": [
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "circles": {
        "weight": "light"
      }
    }
  },
  {
    "name": "clipboard-checklist-cog",
    "keywords": [
      "maintenance"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "clipboard-checkmark",
    "keywords": [
      "icon_already-ordered"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "clipboard-checkmark": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "clipboard-list-checkmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "clipboard-list-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "clipboard-list",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "watchlist": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "clipboard-wrench-screwdriver",
    "keywords": [
      "repair",
      "maintenance"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "clock-arrow-pen",
    "keywords": [
      "career-icon-dual-students-short-duration-of-study"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "clock-arrow-pen": {
        "weight": "light"
      }
    }
  },
  {
    "name": "clock-arrow",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "clock-arrow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "clock",
    "keywords": [
      "clock-time"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "clock": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog-arrows-circle",
    "keywords": [
      "cog"
    ],
    "categories": [
      ""
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "cog-chart",
    "keywords": [
      "bank-icon-flexible-financing-concepts"
    ],
    "categories": [
      "financial"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cog-chart": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog-circles",
    "keywords": [
      "bank-icon-holistic-consulting"
    ],
    "categories": [
      "financial"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cog-circles": {
        "weight": "light"
      }
    }
  },
  {
    "categories": [],
    "description": "",
    "filledWeights": [],
    "keywords": [
      "gear"
    ],
    "legacyNames": {},
    "name": "cog-crossed-document",
    "outlineWeights": [
      "light"
    ]
  },
  {
    "categories": [],
    "description": "",
    "filledWeights": [],
    "keywords": [
      "gear"
    ],
    "legacyNames": {},
    "name": "cog-crossed",
    "outlineWeights": [
      "light"
    ]
  },
  {
    "name": "cog-hands",
    "keywords": [
      "bank-icon-solutions-for-you"
    ],
    "categories": [
      "financial"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cog-hands": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog-multiple",
    "keywords": [
      "three-cogs"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "cog-multiple": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cog",
    "keywords": [
      "gear"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "nav-settings": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "combs",
    "keywords": [
      "smart-factory-icon-products"
    ],
    "categories": [
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "combs": {
        "weight": "light"
      }
    }
  },
  {
    "name": "contact-list",
    "keywords": [
      "mytrumpf-icon-contacts"
    ],
    "categories": [
      "people"
    ],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-contacts": {
        "weight": "light"
      }
    }
  },
  {
    "name": "copy",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "copy": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "crane",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "crane": {
        "weight": "light"
      }
    }
  },
  {
    "name": "cross",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold",
      "normal",
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "ux-input-clearable": {
        "weight": "normal"
      },
      "close-thin": {
        "weight": "light"
      },
      "close": {
        "weight": "normal"
      },
      "close-bold": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "cube",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "decision-tree-symbols",
    "keywords": [
      "solution-guide"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "dialog-secure": {
        "weight": "light"
      }
    }
  },
  {
    "name": "decision-tree",
    "keywords": [
      "solution-guide"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "dialog-secure": {
        "weight": "light"
      }
    }
  },
  {
    "name": "dialog-circles",
    "keywords": [
      "AI",
      "GPT",
      "chatbot"
    ],
    "categories": [
      ""
    ],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "dialog-lock",
    "keywords": [
      "secure-communication"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "dialog-secure": {
        "weight": "light"
      }
    }
  },
  {
    "name": "dialog-thumbs",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "dialog-thumbs": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "dialog",
    "keywords": [
      "smart-factory-icon-well-advised"
    ],
    "categories": [
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "dialog": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-checkmark-pen",
    "keywords": [
      "services-icon-service-agreements"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "document-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-dotted",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "draft": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-invoice-red",
    "keywords": [
      "order",
      "bill"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "document-invoice",
    "keywords": [
      "order",
      "bill"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "document-list-pen",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "document-list-edit": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document-pen-money",
    "keywords": [
      "receive_quotation_icon",
      "general-icon-request-offer",
      "consulting"
    ],
    "categories": [
      "financial"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "financial-quoting": {
        "weight": "light"
      }
    }
  },
  {
    "name": "document",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "file-generic": {
        "weight": "light"
      }
    }
  },
  {
    "name": "documents",
    "keywords": [
      "startpage-icon-orders",
      "orders"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "documents": {
        "weight": "light"
      }
    }
  },
  {
    "name": "earth-generic",
    "keywords": [],
    "categories": [
      "globe"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "globe": {
        "weight": "light"
      }
    }
  },
  {
    "name": "earth",
    "keywords": [
      "responsibility-icon-environment"
    ],
    "categories": [
      "responsibility",
      "globe"
    ],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "globe-fine": {
        "weight": "light"
      },
      "globe-small": {
        "weight": "bold"
      },
      "nav-globe": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "electrical-circuit",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "free-of-interferences": {
        "weight": "light"
      }
    }
  },
  {
    "name": "ellipsis",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "eye-slash",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "eye-striked": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "factory",
    "keywords": [
      "customer-report-icon-industry",
      "smart-factory-company"
    ],
    "categories": [
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "factory": {
        "weight": "light"
      },
      "nav-industry": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "file-bnc",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "file-bnc": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-dxf",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "file-dxf": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-mp4",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "file-mp4": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-pdf",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "file-pdf": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-scdoc",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "file-scdoc": {
        "weight": "light"
      }
    }
  },
  {
    "name": "file-stp",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "file-stp": {
        "weight": "light"
      }
    }
  },
  {
    "name": "filter-horizontal-triple",
    "keywords": [
      "filter"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "filter-horizontal",
    "keywords": [
      "smart-factory-icon-horizontal"
    ],
    "categories": [
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "filter-horizontal": {
        "weight": "light"
      }
    }
  },
  {
    "name": "filter-vertical",
    "keywords": [
      "smart-factory-icon-vertical"
    ],
    "categories": [
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "filter-vertical": {
        "weight": "light"
      }
    }
  },
  {
    "name": "globe-circle-arrows",
    "keywords": [
      "career-icon-working-abroad"
    ],
    "categories": [
      "globe",
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "globe-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "globe-coordinates-pin",
    "keywords": [
      "startpage-icon-locations"
    ],
    "categories": [
      "globe"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "globe-pin": {
        "weight": "light"
      }
    }
  },
  {
    "name": "globe-coordinates",
    "keywords": [],
    "categories": [
      "globe"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "globe-coordinates": {
        "weight": "light"
      }
    }
  },
  {
    "name": "graduation-cap-bag",
    "keywords": [
      "career-icon-graduates-professionals"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "graduates-professionals": {
        "weight": "light"
      }
    }
  },
  {
    "name": "graduation-cap",
    "keywords": [
      "career-icon-graduates"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "graduates": {
        "weight": "light"
      }
    }
  },
  {
    "name": "grid",
    "keywords": [
      "overview"
    ],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "tiles-outline": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "hand-dots-arrow",
    "keywords": [
      "service",
      "case"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "hand-list-arrow",
    "keywords": [
      "service",
      "case"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "hand-plus-right",
    "keywords": [
      "create",
      "case",
      "service"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "hand-plus",
    "keywords": [
      "career-icon-additional-benefits"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "hand-plus": {
        "weight": "light"
      }
    }
  },
  {
    "name": "handshake-pen-paper",
    "keywords": [
      "smart-factory-icon-services"
    ],
    "categories": [
      "services",
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "service-agreement": {
        "weight": "light"
      }
    }
  },
  {
    "name": "hashtag",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "hashtag": {
        "weight": "light"
      }
    }
  },
  {
    "name": "home",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "nav-home": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "horizon",
    "keywords": [
      "career-icon-dual-students-best-perspectives"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "horizon": {
        "weight": "light"
      }
    }
  },
  {
    "name": "hourglass-circle-arrow",
    "keywords": [
      "clock-waiting"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "hourglass-circle-arrow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "jubilee-cake",
    "keywords": [
      "cake",
      "100 years",
      "100 jahre",
      "jubilee"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "lightbulb-checkmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "lightbulb-approved": {
        "weight": "light"
      }
    }
  },
  {
    "name": "lightbulb-cross",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "lightbulb-denied": {
        "weight": "light"
      }
    }
  },
  {
    "name": "lightbulb",
    "keywords": [
      "responsibility-icon-education"
    ],
    "categories": [
      "responsibility"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "lightbulb": {
        "weight": "light"
      }
    }
  },
  {
    "name": "live-indicator",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "logo-facebook",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "social-facebook": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "logo-instagram",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "social-instagram": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "logo-kununu",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "social-kununu": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "logo-line",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "social-line": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "logo-linkedin",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "social-linkedin": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "logo-twitter",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "social-twitter": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "logo-wechat",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "social-wechat": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "logo-x",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "social-x": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "logo-xing",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "social-xing": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "logo-youku",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "logo-youtube",
    "keywords": [],
    "categories": [
      "logos"
    ],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "social-google-plus": {
        "weight": "bold",
        "filled": true
      },
      "social-youtube": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "machine-bookmark",
    "keywords": [],
    "categories": [
      "machines"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-fav": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-chart-magnifier",
    "keywords": [
      "services-icon-condition-analytics"
    ],
    "categories": [
      "machines",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-progress-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-checkmark",
    "keywords": [
      "machine_checkmark-border-right"
    ],
    "categories": [
      "machines"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-checked": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-circle-arrows",
    "keywords": [
      "services-icon-pre-owned-machines",
      "pre-owned"
    ],
    "categories": [
      "machines"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-factory-wifi",
    "keywords": [
      "smart-factory-completely-networked"
    ],
    "categories": [
      "machines",
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-factory-connected": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-gauge",
    "keywords": [],
    "categories": [
      "machines"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-gauge": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-magnifier",
    "keywords": [
      "productfinder",
      "productfinder_with_border"
    ],
    "categories": [
      "machines"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-monitor-controls",
    "keywords": [],
    "categories": [
      "machines"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-screen-control": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-monitor",
    "keywords": [
      "machine_connected-desktop"
    ],
    "categories": [
      "machines"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-desktop": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-plus",
    "keywords": [
      "services-icon-product-enhancements"
    ],
    "categories": [
      "machines",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-plus": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-wifi-multiple",
    "keywords": [
      "smart-factory-adjust-gradually"
    ],
    "categories": [
      "machines",
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-multiple-connected": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine-wifi",
    "keywords": [
      "smart-factory-just-begin"
    ],
    "categories": [
      "machines",
      "smart-factory"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine-connected": {
        "weight": "light"
      }
    }
  },
  {
    "name": "machine",
    "keywords": [
      "startpage-icon-machines"
    ],
    "categories": [
      "machines"
    ],
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "machine": {
        "weight": "light"
      }
    }
  },
  {
    "name": "magnifier-cross",
    "keywords": [
      "search"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "magnifier-long",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "search": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "magnifier-plus",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "magnifier-plus": {
        "weight": "light"
      }
    }
  },
  {
    "name": "magnifier",
    "keywords": [
      "lupe_multi",
      "lupe",
      "search"
    ],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "nav-search": {
        "weight": "bold"
      },
      "search-small": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "mail-arrow-right",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "mail-arrow-right": {
        "weight": "light"
      },
      "mail-arrow-right-green": {
        "weight": "light"
      }
    }
  },
  {
    "name": "mail-checkmark",
    "keywords": [
      "transaction-success"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "mail-approved": {
        "weight": "light"
      }
    }
  },
  {
    "name": "mail-cross",
    "keywords": [
      "transaction-failed"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "mail-denied": {
        "weight": "light"
      }
    }
  },
  {
    "name": "mail-open",
    "keywords": [
      "mail-document",
      "startpage-icon-newsletter"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "mail-open": {
        "weight": "light"
      }
    }
  },
  {
    "name": "mail",
    "keywords": [
      "contact-form",
      "contact"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "mail": {
        "weight": "light"
      },
      "nav-contact": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "manual-tools",
    "keywords": [
      "services-icon-operating-manuals-pt"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "manual-power-tools": {
        "weight": "light"
      }
    }
  },
  {
    "name": "map-germany-pin",
    "keywords": [
      "services-icon-aussendienstsuche"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "germany-pin": {
        "weight": "light"
      }
    }
  },
  {
    "name": "material-bin",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "material-scrap": {
        "weight": "light"
      }
    }
  },
  {
    "name": "material-magnifier",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "material-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "material",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "material": {
        "weight": "light"
      }
    }
  },
  {
    "name": "menu",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "menu": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "message-unread",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "message-unread": {
        "weight": "light"
      }
    }
  },
  {
    "name": "minus",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "minus": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "moneybag",
    "keywords": [
      "moneybag-budget",
      "budget"
    ],
    "categories": [
      "financial"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "financial-moneybag": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-chart-magnifier",
    "keywords": [
      "services-icon-monitoring-and-analysis"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "monitoring": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-code",
    "keywords": [
      "hotspot-fertigung-programmierung"
    ],
    "categories": [
      "hotspot"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "programming": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-cross-magnifier",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "error-analytics": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-documents",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "documents-screen": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-tiles-magnifier",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "tiles-screen-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "name": "monitor-warning-magnifier",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "warning-screen-magnifier": {
        "weight": "light"
      }
    }
  },
  {
    "categories": [
      "services"
    ],
    "description": "",
    "filledWeights": [
      "normal"
    ],
    "outlineWeights": [
      "light"
    ],
    "keywords": [
      "mytrumpf"
    ],
    "legacyNames": {},
    "name": "network-cube"
  },
  {
    "name": "newspaper",
    "keywords": [
      "startpage-icon-press"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "press": {
        "weight": "light"
      }
    }
  },
  {
    "name": "newsroom-magazines",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "newsroom-magazines": {
        "weight": "light"
      }
    }
  },
  {
    "name": "notification-error",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "notification-error": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "notification-information",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "notification-information": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "notification-warning",
    "keywords": [],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "notification-warning": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "octagon-warning",
    "keywords": [
      "hazardous_warning"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "warning": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "package-cross",
    "keywords": [
      "product-error"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "package-error": {
        "weight": "light"
      }
    }
  },
  {
    "name": "packages",
    "keywords": [
      "services-icon-value-packages"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "packages": {
        "weight": "light"
      }
    }
  },
  {
    "name": "paper-plane",
    "keywords": [
      "submit",
      "send",
      "message",
      "email",
      "mail"
    ],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "pause",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "pause": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "pen-wrench",
    "keywords": [
      "career-icon-dual-students-theory-and-practice"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "theory-and-practice": {
        "weight": "light"
      }
    }
  },
  {
    "name": "pencil-line",
    "keywords": [
      "pencil-draw-line"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "pencil-line": {
        "weight": "light"
      }
    }
  },
  {
    "name": "pencil-square",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "edit": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "person-arrows",
    "keywords": [
      "bank-icon-financial-independence"
    ],
    "categories": [
      "people",
      "financial"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "avatar-directions": {
        "weight": "light"
      }
    }
  },
  {
    "name": "phone-circle-arrows",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "phone-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "phone",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "phone": {
        "weight": "light"
      }
    }
  },
  {
    "name": "play",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "play-filled": {
        "weight": "bold",
        "filled": true
      },
      "play": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "plus",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "plus-small": {
        "weight": "bold"
      },
      "plus": {
        "weight": "normal"
      },
      "plus-bold": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "powder",
    "keywords": [
      "services-icon-powder"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "powder": {
        "weight": "light"
      }
    }
  },
  {
    "name": "printer-magnifier",
    "keywords": [
      "print-icon"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "print-search": {
        "weight": "light"
      }
    }
  },
  {
    "name": "process-circle-arrows",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "process-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "questionmark-checkmark",
    "keywords": [
      "icon-questionmark_approved",
      "proactive case closure"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "question-mark-approved": {
        "weight": "light"
      }
    }
  },
  {
    "name": "quotation-mark",
    "keywords": [
      "quotation_down"
    ],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "quotation-mark": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "sample-kit",
    "keywords": [
      "icon-newsroom-media-kits"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "sample-kit": {
        "weight": "light"
      }
    }
  },
  {
    "name": "scales",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "scales": {
        "weight": "light"
      }
    }
  },
  {
    "categories": [],
    "description": "Object Detection",
    "filledWeights": [],
    "keywords": [],
    "legacyNames": {},
    "name": "screw-magnifying-glass",
    "outlineWeights": [
      "light"
    ]
  },
  {
    "name": "share-nodes",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "social-share": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "shield-lock",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "shield-lock": {
        "weight": "light"
      }
    }
  },
  {
    "name": "shipping-truck",
    "keywords": [
      "hotspot-versand"
    ],
    "categories": [
      "hotspot"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "shipping": {
        "weight": "light"
      }
    }
  },
  {
    "name": "shop-devices",
    "keywords": [
      "easy_order_cockpit",
      "services-icon-easy-order-cockpit"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "shop-devices": {
        "weight": "light"
      }
    }
  },
  {
    "name": "showroom",
    "keywords": [
      "services-icon-showroom"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "showroom": {
        "weight": "light"
      }
    }
  },
  {
    "name": "signpost",
    "keywords": [
      "career-icon-professional-development"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "signpost": {
        "weight": "light"
      }
    }
  },
  {
    "name": "smartphone-apps",
    "keywords": [
      "general-icon-apps",
      "services-icon-app"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "smartphone-apps": {
        "weight": "light"
      }
    }
  },
  {
    "name": "snowflake",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "snowflake": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-avatar-registration",
    "keywords": [
      "event-registration"
    ],
    "categories": [
      "people",
      "software"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software-avatar-registration": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-code-cog",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software-code-cog": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-cube-lock",
    "keywords": [
      "services-icon-software-licensing"
    ],
    "categories": [
      "software",
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software-licensing": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-cube",
    "keywords": [
      "services-icon-software"
    ],
    "categories": [
      "software"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-error-404",
    "keywords": [],
    "categories": [
      "software"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software-error-404": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-error-500",
    "keywords": [],
    "categories": [
      "software"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software-error-500": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-gauge",
    "keywords": [
      "high-speed"
    ],
    "categories": [
      "software"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software-speed": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-images",
    "keywords": [
      "icon-newsroom-mediapool"
    ],
    "categories": [
      "software"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software-images": {
        "weight": "light"
      }
    }
  },
  {
    "name": "software-warning-triangle",
    "keywords": [
      "program-window_warning-sign"
    ],
    "categories": [
      "software"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "software-warning": {
        "weight": "light"
      }
    }
  },
  {
    "name": "sort",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "sort": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "square-arrow-in",
    "keywords": [
      "ical",
      "login"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "square-in": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "square-arrow-out",
    "keywords": [
      "logout"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "normal",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "square-out": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "square-info",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "info": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "square",
    "keywords": [
      "bullet-point",
      "bullet"
    ],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "square": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "squares-magnifier",
    "keywords": [
      "career-icon-dual-students-get-to-know-many-departments"
    ],
    "categories": [
      "career"
    ],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "tiles-big-magnifier": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "squares",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light",
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "nav-applications": {
        "weight": "normal"
      },
      "tiles-big": {
        "weight": "light"
      }
    }
  },
  {
    "name": "star",
    "keywords": [
      "favorites_active",
      "favorites_inactive",
      "star-quality",
      "favorites"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "star": {
        "weight": "normal"
      },
      "star-filled": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "thumbs-down",
    "keywords": [
      "hand",
      "dislike",
      "like"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "thumbs-right",
    "keywords": [
      "hand",
      "like"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "sideways version of thumbs-up",
    "legacyNames": {}
  },
  {
    "name": "thumbs-up",
    "keywords": [
      "hand",
      "like"
    ],
    "categories": [],
    "outlineWeights": [
      "light",
      "normal"
    ],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "like": {
        "weight": "light"
      },
      "like-filled": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "ticket",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "ticket": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tiles",
    "keywords": [
      "menu-dotted"
    ],
    "categories": [],
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "description": "",
    "legacyNames": {
      "tiles": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "timer",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "clock-timer": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tools-punching-bending",
    "keywords": [
      "services-icon-tools"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "tools-punching-bending": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tools-punching-scanner",
    "keywords": [
      "services-icon-punching-tool-scanner"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "tools-punching-scanner": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tools-punching",
    "keywords": [
      "services-icon-punching-tools"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "tools-punching": {
        "weight": "light"
      }
    }
  },
  {
    "name": "tools",
    "keywords": [
      "services-icon-repair"
    ],
    "categories": [
      "services"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "tools": {
        "weight": "light"
      }
    }
  },
  {
    "name": "triangle-warning-double",
    "keywords": [
      "warn-sign-double-border",
      "warn-sign"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "warning-triangle": {
        "weight": "light"
      }
    }
  },
  {
    "name": "triangle-warning",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light",
      "bold"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "warning-triangle-simple": {
        "weight": "light"
      }
    }
  },
  {
    "name": "truck-checkmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "truck-checkmark-center": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "truck",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "truck": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "trutops-design",
    "keywords": [
      "software"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "trutops-orientation",
    "keywords": [
      "software"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "trutops-slicing",
    "keywords": [
      "software"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "trutops-support-structures",
    "keywords": [
      "software"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "whiteboard-avatar",
    "keywords": [
      "services-icon-training"
    ],
    "categories": [
      "people",
      "services",
      "career"
    ],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "training-avatar": {
        "weight": "light"
      }
    }
  },
  {
    "name": "whiteboard",
    "keywords": [
      "mytrumpf-icon-trainings"
    ],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "training": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-checkmark",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench-checkmark": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-circle-arrow",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench-circle-arrow": {
        "weight": "light"
      },
      "case-in-progress": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-circle-arrows",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench-circle-arrows": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-clock",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench-clock-arrow": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-cog",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench-cog": {
        "weight": "light"
      }
    }
  },
  {
    "categories": [],
    "description": "",
    "filledWeights": [],
    "keywords": [
      "wrench",
      "tool"
    ],
    "legacyNames": {},
    "name": "wrench-crossed-document",
    "outlineWeights": [
      "light"
    ]
  },
  {
    "categories": [],
    "description": "",
    "filledWeights": [],
    "keywords": [
      "wrench",
      "tool"
    ],
    "legacyNames": {},
    "name": "wrench-crossed",
    "outlineWeights": [
      "light"
    ]
  },
  {
    "name": "wrench-mail-circle-arrow",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "light"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench-circle-arrow-mail-green": {
        "weight": "light"
      }
    }
  },
  {
    "name": "wrench-plus",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench-plus": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "wrench-screwdriver",
    "keywords": [
      "repair"
    ],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {}
  },
  {
    "name": "wrench-simple",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench-simple": {
        "weight": "normal"
      }
    }
  },
  {
    "name": "wrench",
    "keywords": [],
    "categories": [],
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "description": "",
    "legacyNames": {
      "wrench": {
        "weight": "normal"
      }
    }
  }
]
    